import React from "react";
import {Button, NameInput, PasswordInput} from "../../../../components";
import passProfile from "../../../../assets/icons/passProfile.svg";
import { IProps } from "./types";
import { useAppDispatch } from "../../../../redux/store";
import {editPassword} from "../../../../redux/profile/settings/changeDataProfile/slice";
import { useSelector } from "react-redux";
import { changeNameSelector } from "../../../../redux/profile/settings/changeDataProfile/selectors";
import {ErrorMessage, Form, Formik, FormikHelpers} from "formik";
import styles from "../PhoneForm/ChangePhone.module.scss";
import * as Yup from "yup";


export type ValuesType = {
    password: string;
    repeatPassword: string,
};

const Schema = Yup.object().shape({
    password: Yup.string()
        .required("Заполните обязательные поля")
        .min(6, "Пароль должен содержать не менее 6 символов"),
    repeatPassword: Yup.string().when("password", {
        is: (val: string | any[]) => {
            return (val && val.length > 0 ? true : false);
        },
        then: Yup.string().oneOf(
            [Yup.ref("password")],
            "Пароли должны совпадать"
        ).required("Заполните обязательные поля")
    })
});


export const ChangePassword: React.FC<IProps> = ({ close, type,  }) => {
    const dispatch = useAppDispatch();
    const { isLoading } = useSelector(changeNameSelector);
    const handleSubmit = (values: any, actions: FormikHelpers<ValuesType>) => {
        const { password } = values;
        dispatch(editPassword(password));
        close(password, type);
    };

    const initialValues: ValuesType = {
        password: "",
        repeatPassword: "",
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, actions) => handleSubmit(values, actions)}
            validateOnChange={false}
            validateOnBlur={true}
            validationSchema={Schema}
        >
            {(formik) => {
                return (
                    <div>
                        <Form>
                                <div className={styles.formSection}>
                                    <PasswordInput
                                        name="password"
                                        placeholder="Пароль"
                                        lable="Пароль"
                                        
                                    />
                                </div>
                                <div className={styles.formSection}>
                                    <PasswordInput
                                        name="repeatPassword"
                                        placeholder="Повторите пароль"
                                        lable="Повторите пароль"
                                    />
                                </div>
                                <ErrorMessage
                                    component="div"
                                    className={styles.errorMessage}
                                    name="password"
                                />
                            <ErrorMessage
                                component="div"
                                className={styles.errorMessage}
                                name="repeatPassword"
                            />
                            {isLoading ? (
                                <div className={styles.loadingMessage}>данные отправляются</div>
                            ) : null}
                            <Button
                                type="submit"
                                newStyles={styles.button}
                                disabled={formik.isSubmitting}
                            >
                                Готово
                            </Button>
                        </Form>
                    </div>
                );
            }}
        </Formik>
    );
};
